import $ from 'jquery';
import BaseController from 'chairisher/_controller';

import { GlobalPosition, logAmplitudeClickEvent } from 'chairisher/util/analytics';

class SellerCityListController extends BaseController {
    /** @inheritdoc */
    bindPageActions() {
        super.bindPageActions();

        $('.js-breadcrumb').on('click', 'a', (e) => {
            const $currentTarget = $(e.currentTarget);

            logAmplitudeClickEvent($currentTarget.text(), GlobalPosition.BREADCRUMBS, $currentTarget.attr('href'));
        });
    }
}

export default SellerCityListController;
